import styles from "./styles.module.css";
import { useEffect, useState } from "react";
import Color from "./color";
import { Option, Select } from "../select";
export default function Border({ value, onChange, params }) {
  const [_value, _setValue] = useState({
    borderTop: [],
    borderRight: [],
    borderLeft: [],
    borderBottom: [],
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  });
  const [indi, setIndi] = useState(false);

  const handleOnChange = (value) => {
    onChange({
      borderTop: value.borderTop.join(" "),
      borderRight: value.borderRight.join(" "),
      borderLeft: value.borderLeft.join(" "),
      borderBottom: value.borderBottom.join(" "),
      borderTopLeftRadius: value.borderTopLeftRadius,
      borderTopRightRadius: value.borderTopRightRadius,
      borderBottomLeftRadius: value.borderBottomLeftRadius,
      borderBottomRightRadius: value.borderBottomRightRadius,
    });
  };

  const handleSaveAll = (v, index) => {
    const value = { ..._value };

    value.borderTop[index] = v;
    value.borderRight[index] = v;
    value.borderBottom[index] = v;
    value.borderLeft[index] = v;

    _setValue(value);
    handleOnChange(value);
  };
  const handleSaveSingle = (v, index, key) => {
    const value = { ..._value };
    value[key][index] = v;
    _setValue(value);
    handleOnChange(value);
  };

  const updateRadiusAll = (v) => {
    const num = parseInt(v);
    const number = isNaN(num) ? "" : num;
    const value = { ..._value };
    value.borderTopRightRadius = number;
    value.borderTopLeftRadius = number;
    value.borderBottomRightRadius = number;
    value.borderBottomLeftRadius = number;
    _setValue(value);
    handleOnChange(value);
  };

  const updateRadiusSingle = (v, key) => {
    const num = parseInt(v);
    const number = isNaN(num) ? "" : num;
    const value = { ..._value };
    value[key] = number;
    _setValue(value);
    handleOnChange(value);
  };

  useEffect(() => {
    if (value && value.borderTop) {
      _setValue({
        borderTop: value.borderTop.split(" "),
        borderRight: value.borderRight.split(" "),
        borderLeft: value.borderLeft.split(" "),
        borderBottom: value.borderBottom.split(" "),
        borderTopLeftRadius: value.borderTopLeftRadius,
        borderTopRightRadius: value.borderTopRightRadius,
        borderBottomLeftRadius: value.borderBottomLeftRadius,
        borderBottomRightRadius: value.borderBottomRightRadius,
      });
    } else {
      _setValue({
        borderTop: "0px solid #333".split(" "),
        borderRight: "0px solid #333".split(" "),
        borderLeft: "0px solid #333".split(" "),
        borderBottom: "0px solid #333".split(" "),
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      });
    }
  }, [value]);

  if (_value.borderTop.length === 0) {
    return null;
  }

  if (!indi) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
          position: "relative",
        }}
      >
        <div style={{ flexGrow: 1, flexBasis: "40%" }}>
          <div className={styles.borderTitle}>Style</div>
          <Select
            value={_value.borderTop[1]}
            onChange={(v) => handleSaveAll(v, 1)}
            style={{ height: 31 }}
          >
            <Option value={"none"}>none</Option>
            <Option value={"dotted"}>dotted</Option>
            <Option value={"solid"}>solid</Option>
            <Option value={"dashed"}>dashed</Option>
            <Option value={"inset"}>inset</Option>
          </Select>
        </div>
        <div
          style={{
            marginLeft: 4,
            marginRight: 4,
            flexGrow: 1,
            flexBasis: "40%",
          }}
        >
          <div className={styles.borderTitle}>Radius</div>
          <input
            value={_value.borderTopLeftRadius}
            onChange={(e) => updateRadiusAll(e.target.value)}
            type="number"
            className={`${styles.borderInput} input`}
          />
        </div>
        <div
          style={{
            marginLeft: 4,
            marginRight: 4,
            marginTop: 4,
            flexBasis: "40%",
          }}
        >
          <div className={styles.borderTitle}>color</div>
          <Color
            value={_value.borderTop[2]}
            onChange={(v) => handleSaveAll(v, 2)}
          />
        </div>
        <div
          style={{
            marginLeft: 4,
            marginRight: 4,
            marginTop: 4,
            flexGrow: 1,
            flexBasis: "30%",
          }}
        >
          <div className={styles.borderTitle}>width</div>
          <input
            value={_value.borderTop[0].replace("px", "")}
            onChange={(e) => handleSaveAll(e.target.value + "px", 0)}
            type="number"
            className={`${styles.borderInput} input`}
          />
        </div>

        <div onClick={() => setIndi(true)} className={styles.borderButton}>
          Single
        </div>
      </div>
    );
  }
  return (
    <div style={{ width: "100%", position: "relative" }}>
      {[
        { border: "borderTop", radius: "borderTopLeftRadius" },
        { border: "borderRight", radius: "borderTopRightRadius" },
        { border: "borderBottom", radius: "borderBottomRightRadius" },
        { border: "borderLeft", radius: "borderBottomLeftRadius" },
      ].map((position) => {
        return (
          <div className={styles.borderSingle}>
            <div style={{ fontSize: 12, marginBottom: 8, fontWeight: 600 }}>
              {position.border}
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                position: "relative",
              }}
            >
              <div style={{ flexGrow: 1, flexBasis: "40%" }}>
                <div className={styles.borderTitle}>Style</div>
                <Select
                  value={_value[position.border][1]}
                  onChange={(v) => handleSaveSingle(v, 1, position.border)}
                  style={{ height: 31 }}
                >
                  <Option value={"none"}>none</Option>
                  <Option value={"dotted"}>dotted</Option>
                  <Option value={"solid"}>solid</Option>
                  <Option value={"dashed"}>dashed</Option>
                  <Option value={"inset"}>inset</Option>
                </Select>
              </div>
              <div
                style={{
                  marginLeft: 4,
                  marginRight: 4,
                  flexGrow: 1,
                  flexBasis: "40%",
                }}
              >
                <div className={styles.borderTitle}>Radius</div>
                <input
                  value={_value[position.radius]}
                  onChange={(e) =>
                    updateRadiusSingle(e.target.value, position.radius)
                  }
                  type="number"
                  className={`${styles.borderInput} input`}
                />
              </div>
              <div
                style={{
                  marginLeft: 4,
                  marginRight: 4,
                  marginTop: 4,
                  flexBasis: "40%",
                }}
              >
                <div className={styles.borderTitle}>color</div>
                <Color
                  value={_value[position.border][2]}
                  onChange={(v) => handleSaveSingle(v, 2, position.border)}
                />
              </div>
              <div
                style={{
                  marginLeft: 4,
                  marginRight: 4,
                  marginTop: 4,
                  flexGrow: 1,
                  flexBasis: "30%",
                }}
              >
                <div className={styles.borderTitle}>width</div>
                <input
                  value={_value[position.border][0].replace("px", "")}
                  onChange={(e) =>
                    handleSaveSingle(e.target.value + "px", 0, position.border)
                  }
                  type="number"
                  className={`${styles.borderInput} input`}
                />
              </div>
            </div>
          </div>
        );
      })}

      <div
        onClick={() => setIndi(false)}
        className={`${styles.borderButton} ${styles.active}`}
      >
        seprate
      </div>
    </div>
  );
}
